import { createSlice } from "@reduxjs/toolkit";

export const addressDetailsSlice = createSlice({
  name: "addressDetails",
  initialState: {
    country: "NP",
    perCountry: "NP",
    countryDesc: "NEPAL",
    perCountryDesc: "NEPAL",
    errors: {},
  },
  reducers: {
    setCountry: (state, action) => {
      state.country = action.payload;
      state.op = "U";
      state.errors.countryError = {};
      if (state.hasPermanentAddressSame === true) {
        state.perCountry = action.payload;
        state.errors.perCountryError = {};
        state.pop = "U";
      }
    },
    setCountryDesc: (state, action) => {
      state.countryDesc = action.payload;
      state.op = "U";
    },
    setState: (state, action) => {
      state.state = action.payload;
      state.errors.stateError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perState = action.payload;
        state.errors.perStateError = {};
        state.pop = "U";
      }
    },
    setStateDesc: (state, action) => {
      state.stateDesc = action.payload;
      state.op = "U";
    },
    setDistrict: (state, action) => {
      state.district = action.payload;
      state.errors.districtError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perDistrict = action.payload;
        state.errors.perDistrictError = {};
        state.pop = "U";
      }
    },
    setDistrictDesc: (state, action) => {
      state.districtDesc = action.payload;
      state.op = "U";
    },
    setMunicipality: (state, action) => {
      state.municipality = action.payload;
      state.errors.municipalityError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perMunicipality = action.payload;
        state.errors.perMunicipalityError = {};
        state.pop = "U";
      }
    },
    setMunicipalityDesc: (state, action) => {
      state.municipalityDesc = action.payload;
      state.op = "U";
    },
    setWard: (state, action) => {
      state.ward = action.payload;
      state.errors.wardError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perWard = action.payload;
        state.errors.perWardError = {};
        state.pop = "U";
      }
    },
    setTole: (state, action) => {
      state.tole = action.payload;
      state.errors.toleError = {};
      state.op = "U";

      if (state.hasPermanentAddressSame === true) {
        state.perTole = action.payload;
        state.errors.perToleError = {};
        state.pop = "U";
      }
    },
    setBlockNo: (state, action) => {
      state.blockNo = action.payload;
      state.errors.blockNoError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perBlockNo = action.payload;
        state.errors.perBlockNoError = {};
        state.pop = "U";
      }
    },
    setTelephoneNo: (state, action) => {
      state.telephoneNo = action.payload;
      state.errors.telephoneNoError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perTelephoneNo = action.payload;
        state.errors.perTelephoneNoError = {};
        state.pop = "U";
      }
    },
    setEmailId: (state, action) => {
      state.emailId = action.payload;
      state.errors.emailIdError = {};
      state.op = "U";
    },
    setMobileNo: (state, action) => {
      state.mobileNo = action.payload;
      state.errors.mobileNoError = {};
      state.op = "U";
    },
    setHasPermanentAddressSame: (state, action) => {
      state.hasPermanentAddressSame = action.payload;
      if (state.hasPermanentAddressSame === true) {
        state.perCountry = state.country;
        state.perState = state.state;
        state.perDistrict = state.district;
        state.perMunicipality = state.municipality;
        state.perWard = state.ward;
        state.perTole = state.tole;
        state.perBlockNo = state.blockNo;
        state.perTelephoneNo = state.telephoneNo;
        state.errors = {};
        state.perCountryDesc = state.countryDesc;
        state.perStateDesc = state.stateDesc;
        state.perDistrictDesc = state.districtDesc;
        state.perMunicipalityDesc = state.municipalityDesc;
        state.pop = "U";
      } else {
        state.perCountry = null;
        state.perState = null;
        state.perDistrict = null;
        state.perMunicipality = null;
        state.perWard = null;
        state.perTole = '';
        state.perBlockNo = '';
        state.perTelephoneNo = '';
        state.errors = {};
        state.perCountryDesc = '';
        state.perStateDesc = '';
        state.perDistrictDesc = '';
        state.perMunicipalityDesc = '';
        state.pop = "U";
      }
    },
    setPerCountry: (state, action) => {
      state.perCountry = action.payload;
      state.errors.perCountryError = {};
      state.pop = "U";
    },
    setPerCountryDesc: (state, action) => {
      state.countryDesc = action.payload;
    },
    setPerState: (state, action) => {
      state.perState = action.payload;
      state.errors.perStateError = {};
      state.pop = "U";
    },
    setPerStateDesc: (state, action) => {
      state.perStateDesc = action.payload;
      state.pop = "U";
    },
    setPerDistrict: (state, action) => {
      state.perDistrict = action.payload;
      state.errors.perDistrictError = {};
      state.pop = "U";
    },
    setPerDistrictDesc: (state, action) => {
      state.perDistrictDesc = action.payload;
      state.pop = "U";
    },
    setPerMunicipality: (state, action) => {
      state.perMunicipality = action.payload;
      state.errors.perMunicipalityError = {};
      state.pop = "U";
    },
    setPerMunicipalityDesc: (state, action) => {
      state.perMunicipalityDesc = action.payload;
      state.pop = "U";
    },
    setPerWard: (state, action) => {
      state.perWard = action.payload;
      state.errors.perWardError = {};
      state.pop = "U";
    },
    setPerTole: (state, action) => {
      state.perTole = action.payload;
      state.errors.perToleError = {};
      state.pop = "U";
    },
    setPerBlockNo: (state, action) => {
      state.perBlockNo = action.payload;
      state.errors.perBlockNoError = {};
      state.pop = "U";
    },
    setBlockNoError: (state, action) => {
      if (!state.errors.blockNoError) {
        state.errors.blockNoError = {};
      }
      state.errors.blockNoError.message = action.payload.message;
      state.errors.blockNoError.section = action.payload.section;
    },
    setPerBlockNoError: (state, action) => {
      if (!state.errors.perBlockNoError) {
        state.errors.perBlockNoError = {};
      }
      state.errors.perBlockNoError.message = action.payload.message;
      state.errors.perBlockNoError.section = action.payload.section;
    },
    setPerTelephoneNo: (state, action) => {
      state.perTelephoneNo = action.payload;
      state.errors.perTelephoneNoError = {};
      state.pop = "U";
    },
    setLocationType: (state, action) => {
      state.locationType = action.payload;
      state.errors.locationError = {};
    },
    // setLatitude and Longitude
    setLatLng: (state, action) => {
      state.LatLng = action.payload;
      state.latitude = action.payload.mapPosition.lat;
      state.longitude = action.payload.mapPosition.lng;
      state.op = "U";
    },
    setAddressDetailData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => (state[key] = action.payload[key])
      );
      state.pop = "N";
      state.op = "N";
    },

    setCountryError: (state, action) => {
      state.errors.countryError = {};
      state.errors.countryError.message = action.payload.message;
      state.errors.countryError.section = action.payload.section;
    },
    setPerCountryError: (state, action) => {
      state.errors.perCountryError = {};
      state.errors.perCountryError.message = action.payload.message;
      state.errors.perCountryError.section = action.payload.section;
    },
    setStateError: (state, action) => {
      state.errors.stateError = {};
      state.errors.stateError.message = action.payload.message;
      state.errors.stateError.section = action.payload.section;
    },
    setPerStateError: (state, action) => {
      state.errors.perStateError = {};
      state.errors.perStateError.message = action.payload.message;
      state.errors.perStateError.section = action.payload.section;
    },
    setDistrictError: (state, action) => {
      state.errors.districtError = {};
      state.errors.districtError.message = action.payload.message;
      state.errors.districtError.section = action.payload.section;
    },
    setPerDistrictError: (state, action) => {
      state.errors.perDistrictError = {};
      state.errors.perDistrictError.message = action.payload.message;
      state.errors.perDistrictError.section = action.payload.section;
    },
    setPerMunicipalityError: (state, action) => {
      state.errors.perMunicipalityError = {};
      state.errors.perMunicipalityError.message = action.payload.message;
      state.errors.perMunicipalityError.section = action.payload.section;
    },
    setMunicipalityError: (state, action) => {
      state.errors.municipalityError = {};
      state.errors.municipalityError.message = action.payload.message;
      state.errors.municipalityError.section = action.payload.section;
    },
    setWardError: (state, action) => {
      state.errors.wardError = {};
      state.errors.wardError.message = action.payload.message;
      state.errors.wardError.section = action.payload.section;
    },
    setPerWardError: (state, action) => {
      state.errors.perWardError = {};
      state.errors.perWardError.message = action.payload.message;
      state.errors.perWardError.section = action.payload.section;
    },
    setToleError: (state, action) => {
      state.errors.toleError = {};
      state.errors.toleError.message = action.payload.message;
      state.errors.toleError.section = action.payload.section;
    },
    setPerToleError: (state, action) => {
      state.errors.perToleError = {};
      state.errors.perToleError.message = action.payload.message;
      state.errors.perToleError.section = action.payload.section;
    },
    // setError: (state, action) => {
    //   state[action.payload.key] = action.payload.value;
    // },
    setError: (state, action) => {
      state.errors.locationError = {};
      state.errors.locationError.message = action.payload.message;
      state.errors.locationError.section = action.payload.section;
    },
    setEmailIdError: (state, action) => {
      state.errors.emailIdError = {};
      state.errors.emailIdError.message = action.payload.message;
      state.errors.emailIdError.section = action.payload.section;
    },
    setMobileNoError: (state, action) => {
      if (!state.errors.mobileNoError) {
        state.errors.mobileNoError = {};
      }
      state.errors.mobileNoError.message = action.payload.message;
      state.errors.mobileNoError.section = action.payload.section;
    },
    setFaxError: (state, action) => {
      state.errors.faxError = {};
      state.errors.faxError.message = action.payload.message;
      state.errors.faxError.section = action.payload.section;
    },

    setWebsiteError: (state, action) => {
      if (!state.errors.websiteError) {
        state.errors.websiteError = {};
      }
      state.errors.websiteError.message = action.payload.message;
      state.errors.websiteError.section = action.payload.section;
    },
    setTelephoneNoError: (state, action) => {
      state.errors.telephoneNoError = {};
      state.errors.telephoneNoError.message = action.payload.message;
      state.errors.telephoneNoError.section = action.payload.section;
    },
    setPerTelephoneNoError: (state, action) => {
      state.errors.perTelephoneNoError = {};
      state.errors.perTelephoneNoError.message = action.payload.message;
      state.errors.perTelephoneNoError.section = action.payload.section;
    },

    clearAddressData: (state, action) => {
      state.pop = "N";
      state.op = "N";
    },
    setAddressData: (state, action) => {
      state[action.payload.key] = action.payload.value;
      state.op = "U";
    },
    appendAddressTempData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => {
          state[key] = action.payload[key];
          switch (key) {
            case 'country':
              state.state = null;
            case 'state':
              state.district = null;
            case 'district':
              state.municipality = null;
            case 'municipality':
              state.ward = null;
          }
          state.errors && (state.errors[key + 'Error'] = {});
          if (state.hasPermanentAddressSame) {
            switch (key) {
              case 'country':
                state.perState = null;
              case 'state':
                state.perDistrict = null;
              case 'district':
                state.perMunicipality = null;
              case 'municipality':
                state.perWard = null;
            }
            state.pop = "U";
            state['per' + key.charAt(0).toUpperCase() + key.substring(1)] = action.payload[key];
            state.errors && (state.errors['per' + key.charAt(0).toUpperCase() + key.substring(1) + 'Error'] = {});
          }
        }
      );
      state.op = "U";
    },
    appendAddressPermData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => {
          state[key] = action.payload[key];
          state.errors && (state.errors[key + 'Error'] = {});
          switch (key) {
            case 'perCountry':
              state.perState = null;
            case 'perState':
              state.perDistrict = null;
            case 'perDistrict':
              state.perMunicipality = null;
            case 'perMunicipality':
              state.perWard = null;
          }
        }
      );
      state.pop = "U";
    },
    clearAddressError: (state) => {
      state.errors = {};
    },
  },
});

export const {
  appendAddressPermData,
  appendAddressTempData,
  setAddressData,
  setError,
  clearAddressData,
  setCountry,
  setCountryDesc,
  setState,
  setStateDesc,
  setDistrict,
  setDistrictDesc,
  setAddressDetailData,
  setMunicipality,
  setMunicipalityDesc,
  setWard,
  setTole,
  setBlockNo,
  setTelephoneNo,
  setEmailId,
  setMobileNo,
  setHasPermanentAddressSame,
  setPerCountry,
  setPerCountryDesc,
  setPerState,
  setPerStateDesc,
  setPerDistrict,
  setPerDistrictDesc,
  setPerMunicipality,
  setPerMunicipalityDesc,
  setPerWard,
  setPerTole,
  setPerBlockNo,
  setPerTelephoneNo,
  setLocationType,
  setLatLng,
  setCountryError,
  setPerCountryError,
  setStateError,
  setPerStateError,
  setDistrictError,
  setPerDistrictError,
  setMunicipalityError,
  setPerMunicipalityError,
  setWardError,
  setPerWardError,
  setToleError,
  setPerToleError,
  setBlockNoError,
  setPerBlockNoError,
  setFaxError,
  setEmailIdError,
  setWebsiteError,
  setMobileNoError,
  setTelephoneNoError,
  setPerTelephoneNoError,
  clearAddressError,
} = addressDetailsSlice.actions;

export default addressDetailsSlice.reducer;
